import { BaseModel } from '@nuxtDatakodeUtils/models/BaseModel'

export class Commune extends BaseModel<any> { // TODO add CommentData type
    endPoint: string = 'communes'
    translationKey: string = 'communes'
    permissionName: string = 'communes'
}
